import { render, staticRenderFns } from "./companyDelete.vue?vue&type=template&id=03c7846e&"
import script from "./companyDelete.vue?vue&type=script&lang=js&"
export * from "./companyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports